import { Modal } from "./";
import { CustomButton, CustomInput } from "./";
import { COLORS } from "../constants";
import axios from "axios"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import styled from "styled-components"

const TextArea = styled.textarea`
    width: 100%;
    min-height: 200px;

    background-color: ${COLORS.light_grey};
    border: solid 3px ${COLORS.light_grey_darker};
    border-radius: 10px;
    padding: 0 10px;
    -webkit-appearance: none;
    transition: border-color 0.2s;

    &:hover{
        border: solid 3px ${COLORS.light_grey_darker_hover};
    }
    &:focus{
        outline: none;
        border: solid 3px ${COLORS.light_grey_darker_hover};
    }

`;
export function ComplaintModal(props) {
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user)
    const [subject, setSubject] = useState('');
    const [desc, setDesc] = useState('');
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        setLoading(true);
        if (subject.length > 0 && desc.length > 0) {

            const response = await axios.post(`${api}/qt/submit_complaint`, { email_id: user.user.email, subject: subject, message: desc });

            const data = response.data;


            if (data.status == "success") {
                alert("Complaint Submitted Successfully")
                props.onClose();

                setTimeout(() => {
                    setSubject('');
                    setDesc('');
                    setError(false);
                    setLoading(false);
                }, 500);
            }

        } else {
            setError(true);
            setLoading(false);
        }

    }

    return (
        <Modal modalVisible={props.visible} onClose={() => {

            setSubject('');
            setDesc('');
            setSuccess(null)
            setError(false)
            props.onClose();
        }} width="40%">
            {user ? user.user_role == 1 || user.user_role == 2 ?
                <div>
                    <h5 className="color-text-dark-blue">Submit a Feedback</h5>
                    <div>Your feedback will help us to improve the application.</div>
                    <div className="mt-3">Subject</div>
                    <CustomInput type="text" className="w-100 mt-1" value={subject} onChange={(event) => {
                        setSubject(event.target.value)
                        setError(false)
                    }} />
                    <div className="mt-3">Description</div>
                    <TextArea value={desc} className="mt-1" onChange={(event) => {
                        setDesc(event.target.value)
                        setError(false)
                    }} placeholder="Describe the problem, when and where it has been occurring." />
                    {error && <div className="mt-2" style={{ color: "red" }}>Check your data</div>}
                    <div className="justify-content-between d-flex mt-3">
                        <CustomButton className="px-4"
                            color={COLORS.dark_orange}
                            bgColor={COLORS.orange}
                            hover={COLORS.orange_hover}
                            onClick={() => {

                                setSubject('');
                                setDesc('');
                                setSuccess(null);
                                setError(false);
                                props.onClose();
                            }}
                        >
                            Decline
                        </CustomButton>
                        <CustomButton className="px-4"
                            color={COLORS.text_dark_green}
                            bgColor={COLORS.green}
                            hover={COLORS.darker_green}
                            onClick={submit}
                            disabled={loading}
                        >
                            {loading ? "Loading..." : "Submit"}
                        </CustomButton>
                    </div>
                </div>
                : <div><h5 className="color-text-dark-blue">Submit a Feedback</h5><h6>Sorry, only registered parents and teachers can submit app feedback.</h6></div>

                : <div><h5 className="color-text-dark-blue">Submit a Feedback</h5><h6>Sorry, only registered parents and teachers can submit app feedback.</h6></div>}


        </Modal>
    )
}
